module.exports = function () {
  const videos = document.querySelectorAll('video.lazy');
  if (!videos) return;
  const observerConfig = {
    rootMargin: '150px 0px'
  };

  const srcObserver = new IntersectionObserver( function(entries) {
    entries.forEach(function(entry) {
      if (entry.intersectionRatio > 0) {
        const source = entry.target.getAttribute('data-src');
        entry.target.innerHTML = `<source src="${source}" type="video/mp4">`;
        srcObserver.unobserve(entry.target);
      }
    });
  }, observerConfig);

  videos.forEach( function(video) {
    srcObserver.observe(video);
  });
}
